// src/crm/dashboard/useCrmStats.ts
import type { Deal, Campaign, DealStage } from '../../lib/types'
import { STAGES } from '../pipeline/stages'

export type CrmStats = {
  activeCreators: number
  totalInstalls: number
  totalViews: number
  totalBudget: number
  dealsByStage: Record<DealStage, number>
}

export function computeCrmStats(deals: Deal[], campaigns: Campaign[]): CrmStats {
  const creatorIds = new Set(deals.map((d) => d.creatorId))

  let totalInstalls = 0
  let totalViews = 0
  for (const deal of deals) {
    for (const del of deal.deliverables) {
      totalInstalls += del.installsAttributed ?? 0
      totalViews += del.views ?? 0
    }
  }

  const totalBudget = campaigns.reduce((sum, c) => sum + (c.budgetAmount ?? 0), 0)

  const dealsByStage = STAGES.reduce<Record<DealStage, number>>(
    (acc, s) => {
      acc[s] = deals.filter((d) => d.stage === s).length
      return acc
    },
    {} as Record<DealStage, number>,
  )

  return {
    activeCreators: creatorIds.size,
    totalInstalls,
    totalViews,
    totalBudget,
    dealsByStage,
  }
}
